import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const MicrosoftCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [status, setStatus] = useState('Processing Microsoft login...');
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      if (errorParam) {
        setError(errorDescription || `Microsoft login failed: ${errorParam}`);
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      if (!code) {
        setError('No authorization code received from Microsoft');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      try {
        setStatus('Authenticating with server...');

        const response = await api.post('/auth/microsoft/callback/', { code });
        const { access, refresh, user } = response.data;

        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);
        localStorage.setItem('user', JSON.stringify(user));

        setStatus('Login successful! Redirecting...');

        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      } catch (err: any) {
        console.error('Microsoft callback error:', err);
        const errorMsg = err.response?.data?.error ||
                        err.response?.data?.detail ||
                        'Failed to complete Microsoft login';
        setError(errorMsg);
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="container" style={{ maxWidth: '500px', marginTop: '4rem' }}>
      <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
        {error ? (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#x274C;</div>
            <h2 style={{ color: '#e74c3c', marginBottom: '1rem' }}>Login Failed</h2>
            <div className="error">{error}</div>
            <p style={{ marginTop: '1rem', color: '#7f8c8d' }}>
              Redirecting to login page...
            </p>
          </>
        ) : (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
              <div className="spinner" style={{
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #0078d4',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                animation: 'spin 1s linear infinite',
                margin: '0 auto'
              }}></div>
            </div>
            <h2 style={{ marginBottom: '1rem' }}>Signing you in...</h2>
            <p style={{ color: '#7f8c8d' }}>{status}</p>
          </>
        )}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default MicrosoftCallback;
